import { render, staticRenderFns } from "./DivisionEditor.vue?vue&type=template&id=297f49c7"
import script from "./DivisionEditor.vue?vue&type=script&lang=js"
export * from "./DivisionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports